import React from "react";

import "./styles.css";

function Spinner() {
  return <div className="loader"></div>;
}

export default Spinner;
